import 'air-datepicker/air-datepicker.css'

import AirDatepicker from 'air-datepicker'
import localeEn from 'air-datepicker/locale/en'
import { Calendar } from 'lucide-react'
import React, { useEffect, useRef } from 'react'

function AirDatepickerReact ({ id, options }: any) {
  const $input = useRef() as any
  const dp = useRef() as any

  useEffect(() => {
    dp.current = new AirDatepicker($input.current, { locale: localeEn, ...options })
  }, [options])

  useEffect(() => {
    dp.current.update({ ...options })
  }, [options])

  return (
    <div className='flex flex-col max-w-[13rem] sm:max-w-[12rem] items-left'>
      <div className='relative mt-2 rounded-md shadow-sm mx-auto'>
        <div className='pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3'>
          <Calendar size={20} color='#9ca3af' />
        </div>
        <input
          id={id}
          name={id}
          ref={$input}
          required
          placeholder='Select a date'
          className='input-default pl-10'
          readOnly
        />
      </div>
    </div>
  )
}

export default AirDatepickerReact
